"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledSemiBold = exports.StyledPlaceholder = exports.StyledParagraph = exports.StyledP = exports.StyledLabelText = exports.StyledHelperText = exports.StyledH3 = exports.StyledH2 = exports.StyledH1 = exports.StyledDisplayText = exports.StyledCaptionText = exports.StyledButtonText = exports.StyledBodySmall = exports.StyledBodyLight = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _utils = require("../lib/utils");

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject10, _templateObject11, _templateObject12, _templateObject13, _templateObject14;

var StyledP = _styledComponents["default"].p(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2["default"])(["\n  font-size: 24px;\n  &.regular {\n    ", ";\n  }\n  &.semibold {\n    ", ";\n  }\n  &.medium {\n    ", ";\n  }\n"])), function (props) {
  return props.theme.typography.fontFamily.regular;
}, function (props) {
  return props.theme.typography.fontFamily.semibold;
}, function (props) {
  return props.theme.typography.fontFamily.medium;
});

exports.StyledP = StyledP;

var StyledParagraph = _styledComponents["default"].p(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2["default"])(["\n  ", "\n  ", "\n  color: ", "\n"])), function (props) {
  return (0, _utils.getTypography)('body')(props);
}, function (props) {
  return (0, _utils.isRTL)(props) && "text-align: right;";
}, function (props) {
  return (0, _utils.getPalette)(props.color, props.shade)(props);
});

exports.StyledParagraph = StyledParagraph;

var StyledBodyLight = _styledComponents["default"].p(_templateObject3 || (_templateObject3 = (0, _taggedTemplateLiteral2["default"])(["\n  ", "\n  ", "\n  color: ", "\n"])), function (props) {
  return (0, _utils.getTypography)('bodyLight')(props);
}, function (props) {
  return (0, _utils.isRTL)(props) && "text-align: right;";
}, function (props) {
  return (0, _utils.getPalette)(props.color, props.shade)(props);
});

exports.StyledBodyLight = StyledBodyLight;

var StyledSemiBold = _styledComponents["default"].p(_templateObject4 || (_templateObject4 = (0, _taggedTemplateLiteral2["default"])(["\n  ", "\n  ", "\n  color: ", "\n"])), function (props) {
  return (0, _utils.getTypography)('bodySemiBold')(props);
}, function (props) {
  return (0, _utils.isRTL)(props) && "text-align: right;";
}, function (props) {
  return (0, _utils.getPalette)(props.color, props.shade)(props);
});

exports.StyledSemiBold = StyledSemiBold;

var StyledCaptionText = _styledComponents["default"].p(_templateObject5 || (_templateObject5 = (0, _taggedTemplateLiteral2["default"])(["\n  ", "\n  ", "\n  color: ", "\n"])), function (props) {
  return (0, _utils.getTypography)('captionText')(props);
}, function (props) {
  return (0, _utils.isRTL)(props) && "text-align: right;";
}, function (props) {
  return (0, _utils.getPalette)(props.color, props.shade)(props);
});

exports.StyledCaptionText = StyledCaptionText;

var StyledH1 = _styledComponents["default"].h1(_templateObject6 || (_templateObject6 = (0, _taggedTemplateLiteral2["default"])(["\n  ", "\n  ", "\n  color: ", "\n"])), function (props) {
  return (0, _utils.getTypography)('h1')(props);
}, function (props) {
  return (0, _utils.isRTL)(props) && "text-align: right;";
}, function (props) {
  return (0, _utils.getPalette)(props.color, props.shade)(props);
});

exports.StyledH1 = StyledH1;

var StyledH2 = _styledComponents["default"].h2(_templateObject7 || (_templateObject7 = (0, _taggedTemplateLiteral2["default"])(["\n  ", "\n  ", "\n  color: ", "\n"])), function (props) {
  return (0, _utils.getTypography)('h2')(props);
}, function (props) {
  return (0, _utils.isRTL)(props) && "text-align: right;";
}, function (props) {
  return (0, _utils.getPalette)(props.color, props.shade)(props);
});

exports.StyledH2 = StyledH2;

var StyledH3 = _styledComponents["default"].h3(_templateObject8 || (_templateObject8 = (0, _taggedTemplateLiteral2["default"])(["\n  ", "\n  ", "\n  color: ", "\n"])), function (props) {
  return (0, _utils.getTypography)('h3')(props);
}, function (props) {
  return (0, _utils.isRTL)(props) && "text-align: right;";
}, function (props) {
  return (0, _utils.getPalette)(props.color, props.shade)(props);
});

exports.StyledH3 = StyledH3;

var StyledLabelText = _styledComponents["default"].div(_templateObject9 || (_templateObject9 = (0, _taggedTemplateLiteral2["default"])(["\n  ", "\n  ", "\n  color: ", "\n"])), function (props) {
  return (0, _utils.getTypography)('label')(props);
}, function (props) {
  return (0, _utils.isRTL)(props) && "text-align: right;";
}, function (props) {
  return (0, _utils.getPalette)(props.color, props.shade)(props);
});

exports.StyledLabelText = StyledLabelText;

var StyledHelperText = _styledComponents["default"].div(_templateObject10 || (_templateObject10 = (0, _taggedTemplateLiteral2["default"])(["\n  ", "\n  ", "\n  color: ", "\n"])), function (props) {
  return (0, _utils.getTypography)('helperText')(props);
}, function (props) {
  return (0, _utils.isRTL)(props) && "text-align: right;";
}, function (props) {
  return (0, _utils.getPalette)(props.color, props.shade)(props);
});

exports.StyledHelperText = StyledHelperText;

var StyledButtonText = _styledComponents["default"].div(_templateObject11 || (_templateObject11 = (0, _taggedTemplateLiteral2["default"])(["\n  ", "\n  ", "\n  color: ", "\n"])), function (props) {
  return (0, _utils.getTypography)('buttonText')(props);
}, function (props) {
  return (0, _utils.isRTL)(props) && "text-align: right;";
}, function (props) {
  return (0, _utils.getPalette)(props.color, props.shade)(props);
});

exports.StyledButtonText = StyledButtonText;

var StyledPlaceholder = _styledComponents["default"].div(_templateObject12 || (_templateObject12 = (0, _taggedTemplateLiteral2["default"])(["\n  ", "\n  ", "\n  color: ", "\n"])), function (props) {
  return (0, _utils.getTypography)('placeholder')(props);
}, function (props) {
  return (0, _utils.isRTL)(props) && "text-align: right;";
}, function (props) {
  return (0, _utils.getPalette)(props.color, props.shade)(props);
});

exports.StyledPlaceholder = StyledPlaceholder;

var StyledBodySmall = _styledComponents["default"].p(_templateObject13 || (_templateObject13 = (0, _taggedTemplateLiteral2["default"])(["\n  ", "\n  ", "\n  color: ", "\n"])), function (props) {
  return (0, _utils.getTypography)('bodySmall')(props);
}, function (props) {
  return (0, _utils.isRTL)(props) && "text-align: right;";
}, function (props) {
  return (0, _utils.getPalette)(props.color, props.shade)(props);
});

exports.StyledBodySmall = StyledBodySmall;

var StyledDisplayText = _styledComponents["default"].p(_templateObject14 || (_templateObject14 = (0, _taggedTemplateLiteral2["default"])(["\n  ", "\n  ", "\n  color: ", "\n"])), function (props) {
  return (0, _utils.getTypography)('displayText')(props);
}, function (props) {
  return (0, _utils.isRTL)(props) && "text-align: right;";
}, function (props) {
  return (0, _utils.getPalette)(props.color, props.shade)(props);
});

exports.StyledDisplayText = StyledDisplayText;